export function findId(href: string): string {
    const lastSlashIndex = href.lastIndexOf('/');

    return lastSlashIndex !== -1 ? href.substring(lastSlashIndex + 1) : '';
}
